<template>
    <section class="contact-area ptb-100">
        <div class="container">
            <div class="contact-inner">
                <div class="row">
                    <div class="col-lg-6 col-md-12" data-aos="fade-right">
                        <div class="contact-features-list">
                            <h3>Weitere gute Gründe, uns zu wählen</h3>
                            <p>Machen Sie den ersten Schritt zu mehr Produktivität und weniger Stress mit Benovium.</p>
                            <p>Wir sind ein hochqualifiziertes, engagiertes Team, das Unternehmer, Fachleute und kleine Teams dabei unterstützt, erfolgreich zu sein - nicht nur bei der Arbeit, sondern auch im Leben. Wir helfen Ihnen, sich auf das Wesentliche zu konzentrieren, indem wir uns um die Details kümmern.</p>

                            <ul>
                                <li><i class='bx bx-badge-check'></i> Unser Team arbeitet von Wien aus</li>
                                <li><i class='bx bx-badge-check'></i> Flexibel skalierbar nach Bedarf</li>
                                <li><i class='bx bx-badge-check'></i> Einmalige oder laufende Projekte</li>
                                <li><i class='bx bx-badge-check'></i> Auswahl nach Kompetenz</li>
                            </ul>
                        </div>
                    </div>

                    <div class="col-lg-6 col-md-12" data-aos="fade-left" data-aos-delay="100">
                        <div class="contact-form">
                            <h3>Schreiben Sie uns eine Nachricht</h3>

                            <!-- Success Message -->
                            <div v-if="submitStatus === 'success'" class="alert alert-success">
                                <i class='bx bx-check-circle'></i>
                                Vielen Dank! Ihre Nachricht wurde erfolgreich gesendet. Wir melden uns in Kürze bei Ihnen.
                            </div>

                            <!-- Error Message -->
                            <div v-if="submitStatus === 'error'" class="alert alert-error">
                                <i class='bx bx-error-circle'></i>
                                Es ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut oder kontaktieren Sie uns direkt per E-Mail.
                            </div>

                            <form @submit.prevent="submitForm" v-if="submitStatus !== 'success'">
                                <!-- Web3Forms Access Key -->
                                <input type="hidden" name="access_key" :value="accessKey">
                                <!-- Subject for Email -->
                                <input type="hidden" name="subject" value="Neue Kontaktanfrage von Benovium Website">
                                <!-- From Name -->
                                <input type="hidden" name="from_name" value="Benovium Kontaktformular">

                                <div class="row">
                                    <div class="col-lg-6 col-md-6">
                                        <div class="form-group">
                                            <input
                                                type="text"
                                                name="name"
                                                v-model="formData.name"
                                                class="form-control"
                                                placeholder="Ihr Name"
                                                required
                                            >
                                        </div>
                                    </div>

                                    <div class="col-lg-6 col-md-6">
                                        <div class="form-group">
                                            <input
                                                type="email"
                                                name="email"
                                                v-model="formData.email"
                                                class="form-control"
                                                placeholder="Ihre E-Mail"
                                                required
                                            >
                                        </div>
                                    </div>

                                    <div class="col-lg-6 col-md-6">
                                        <div class="form-group">
                                            <input
                                                type="text"
                                                name="phone"
                                                v-model="formData.phone"
                                                class="form-control"
                                                placeholder="Ihre Telefonnummer"
                                            >
                                        </div>
                                    </div>

                                    <div class="col-lg-6 col-md-6">
                                        <div class="form-group">
                                            <input
                                                type="text"
                                                name="betreff"
                                                v-model="formData.betreff"
                                                class="form-control"
                                                placeholder="Betreff"
                                                required
                                            >
                                        </div>
                                    </div>

                                    <div class="col-lg-12 col-md-12">
                                        <div class="form-group">
                                            <textarea
                                                name="message"
                                                v-model="formData.message"
                                                class="form-control"
                                                cols="30"
                                                rows="6"
                                                placeholder="Ihre Nachricht"
                                                required
                                            ></textarea>
                                        </div>
                                    </div>

                                    <div class="col-lg-12 col-md-12">
                                        <button
                                            type="submit"
                                            class="default-btn"
                                            :disabled="isSubmitting"
                                        >
                                            <i :class="isSubmitting ? 'bx bx-loader-alt bx-spin' : 'bx bxs-paper-plane'"></i>
                                            {{ isSubmitting ? 'Wird gesendet...' : 'Nachricht senden' }}
                                            <span></span>
                                        </button>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>

                <div class="contact-info" data-aos="fade-up" data-aos-delay="200">
                    <div class="contact-info-content">
                        <h3>Oder erreichen Sie uns direkt</h3>
                        <p class="contact-subtitle">Wählen Sie Ihren bevorzugten Kommunikationsweg</p>

                        <div class="contact-cards">
                            <a href="tel:+436605782160" class="contact-card">
                                <div class="contact-card-icon">
                                    <i class='bx bx-phone-call'></i>
                                </div>
                                <div class="contact-card-content">
                                    <h4>Telefon</h4>
                                    <p>+43 660 578 2160</p>
                                    <span class="contact-card-hint">Jetzt anrufen</span>
                                </div>
                            </a>

                            <a href="mailto:office@benovium.com" class="contact-card">
                                <div class="contact-card-icon">
                                    <i class='bx bx-envelope'></i>
                                </div>
                                <div class="contact-card-content">
                                    <h4>E-Mail</h4>
                                    <p>office@benovium.com</p>
                                    <span class="contact-card-hint">E-Mail schreiben</span>
                                </div>
                            </a>

                            <a href="https://wa.me/436605782160" target="_blank" class="contact-card">
                                <div class="contact-card-icon">
                                    <i class='bx bxl-whatsapp'></i>
                                </div>
                                <div class="contact-card-content">
                                    <h4>WhatsApp</h4>
                                    <p>Schnell & unkompliziert</p>
                                    <span class="contact-card-hint">Chat starten</span>
                                </div>
                            </a>
                        </div>

                        <!-- <ul class="social">
                            <li><a href="https://www.facebook.com/" target="_blank"><i class="bx bxl-facebook"></i></a></li>
                            <li><a href="https://twitter.com/" target="_blank"><i class="bx bxl-twitter"></i></a></li>
                            <li><a href="https://www.linkedin.com/" target="_blank"><i class="bx bxl-linkedin"></i></a></li>
                            <li><a href="https://www.instagram.com/" target="_blank"><i class="bx bxl-instagram"></i></a></li>
                        </ul> -->
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
export default {
    name: 'Contact',
    data() {
        return {
            accessKey: 'd61744f2-1b59-4824-8947-44e8562c8155', // <-- Hier deinen Key eintragen
            isSubmitting: false,
            submitStatus: null,
            formData: {
                name: '',
                email: '',
                phone: '',
                betreff: '',
                message: ''
            }
        }
    },
    methods: {
        async submitForm() {
            this.isSubmitting = true;
            this.submitStatus = null;

            try {
                const response = await fetch('https://api.web3forms.com/submit', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'Accept': 'application/json'
                    },
                    body: JSON.stringify({
                        access_key: this.accessKey,
                        subject: 'Neue Kontaktanfrage von Benovium Website',
                        from_name: 'Benovium Development e.U. Kontaktformular',
                        name: this.formData.name,
                        email: this.formData.email,
                        phone: this.formData.phone,
                        betreff: this.formData.betreff,
                        message: this.formData.message
                    })
                });

                const result = await response.json();

                if (result.success) {
                    this.submitStatus = 'success';
                    // Reset form
                    this.formData = {
                        name: '',
                        email: '',
                        phone: '',
                        betreff: '',
                        message: ''
                    };
                } else {
                    this.submitStatus = 'error';
                }
            } catch (error) {
                console.error('Form submission error:', error);
                this.submitStatus = 'error';
            } finally {
                this.isSubmitting = false;
            }
        }
    }
}
</script>

<style scoped>
.alert {
    padding: 15px 20px;
    border-radius: 8px;
    margin-bottom: 20px;
    display: flex;
    align-items: center;
    gap: 10px;
}

.alert i {
    font-size: 24px;
}

.alert-success {
    background-color: #d4edda;
    color: #155724;
    border: 1px solid #c3e6cb;
}

.alert-error {
    background-color: #f8d7da;
    color: #721c24;
    border: 1px solid #f5c6cb;
}

button:disabled {
    opacity: 0.7;
    cursor: not-allowed;
}

.bx-spin {
    animation: spin 1s linear infinite;
}

@keyframes spin {
    from { transform: rotate(0deg); }
    to { transform: rotate(360deg); }
}

/* Contact Cards */
.contact-subtitle {
    color: #666;
    margin-bottom: 30px;
    font-size: 16px;
}

.contact-cards {
    display: flex;
    gap: 20px;
    justify-content: center;
    flex-wrap: wrap;
}

.contact-card {
    display: flex;
    align-items: center;
    gap: 15px;
    background: #fff;
    padding: 25px 30px;
    border-radius: 12px;
    box-shadow: 0 5px 30px rgba(0, 0, 0, 0.08);
    text-decoration: none;
    transition: all 0.3s ease;
    min-width: 280px;
    border: 2px solid #eee;
}

.contact-card:hover {
    transform: translateY(-5px);
    box-shadow: 0 15px 40px rgba(0, 0, 0, 0.12);
    border-color: #000;
}

.contact-card-icon {
    width: 60px;
    height: 60px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    background: #000;
    transition: all 0.3s ease;
}

.contact-card-icon i {
    font-size: 28px;
    color: #fff;
}

.contact-card:hover .contact-card-icon {
    background: #fff;
    border: 2px solid #000;
}

.contact-card:hover .contact-card-icon i {
    color: #000;
}

.contact-card-content h4 {
    font-size: 18px;
    color: #000;
    margin-bottom: 5px;
    font-weight: 600;
}

.contact-card-content p {
    color: #666;
    font-size: 14px;
    margin-bottom: 5px;
}

.contact-card-hint {
    font-size: 12px;
    color: #000;
    font-weight: 500;
    text-transform: uppercase;
    letter-spacing: 0.5px;
}

@media (max-width: 768px) {
    .contact-cards {
        flex-direction: column;
        align-items: center;
    }

    .contact-card {
        width: 100%;
        max-width: 350px;
        min-width: auto;
    }
}
</style>
